import {
    MenuItemComponent as SourceMenuItemComponent,
} from 'SourceComponent/MenuItem/MenuItem.component';

import './MenuItem.override.style';
import MinusIcon from '@scandipwa/scandipwa/src/component/MinusIcon';
import AddIcon from '@scandipwa/scandipwa/src/component/AddIcon';
import React from 'react';
import { noopFn } from '@scandipwa/scandipwa/src/util/Common';
import Link from '@scandipwa/scandipwa/src/component/Link';
import { getSortedItems } from '@scandipwa/scandipwa/src/util/Menu';

export class MenuItemComponent extends SourceMenuItemComponent {
    static defaultProps = {
        onItemClick: noopFn,
    };

    renderPlusMinusIcon() {
        const { itemMods: { isExpanded } } = this.props;

        if (isExpanded) {
            return <MinusIcon />;
        }

        return <AddIcon />;
    }

    renderExpandButton() {
        const { isExpandable, itemMods } = this.props;

        if (!isExpandable) {
            return null;
        }

        return (
            <figcaption className={itemMods ? 'Menu-ExpandedState Menu-ExpandedState_type_main' : 'Menu-ExpandedState'}>
                {this.renderPlusMinusIcon()}
            </figcaption>
        );
    }

    renderItemContent(item, itemMods) {
        const { title, labelwithimage, children } = item;
        const childrenArray = getSortedItems(Object.values(children));

        if (labelwithimage && childrenArray.length <= 0) {
            return null;
        }

        return (
            <figcaption className={itemMods ? `Menu-ItemCaption Menu-ItemCaption_type_${itemMods?.type}` : 'Menu-ItemCaption'}>
                {
                    labelwithimage !== null && childrenArray.length <= 0 ?
                        <></> :
                        // <img src={`/media/${labelwithimage}`} /> :
                        <>
                            {item.icon ? <img className='menu-category-icon' src={`/media/${item.icon}`} /> : ""}
                            <span className='menu-categories-title'>{title}</span>
                        </>
                }
                {itemMods?.type === "main" ? this.renderExpandButton() : ""}
            </figcaption>
        );
    }

    renderItemLinkContent() {
        const {
            activeMenuItemsStack,
            item,
            itemMods,
            handleCategoryHover,
            handleLinkLeave,
            onItemClick,
        } = this.props;

        const {
            url,
            item_id,
        } = item;

        const isHovered = activeMenuItemsStack.includes(item_id);

        return (
            <Link
                to={url}
                block="Menu"
                elem="Link"
                id={item_id}
                onMouseEnter={handleCategoryHover}
                onMouseLeave={handleLinkLeave}
                mods={{ isHovered }}
                onClick={onItemClick}
            >
                {this.renderItemContent(item, itemMods)}
            </Link>
        );
    }

    render() {
        const { item, itemMods, isLink } = this.props;

        if (isLink) {
            return this.renderItemLinkContent();
        }

        return this.renderItemContent(item, itemMods);
    }
}

export default MenuItemComponent;
